import PropTypes from 'prop-types';
import React from 'react';
import { Button, InsurerHandoverButton } from 'ctm-components';

/**
 * The api schema
 */
const api = {
    url: '/event',
    type: 'POST',
    requestAction: 'ONLINE_HANDOVER',
    requestPayload: 'lead',
    failureType: 'non-fatal'
};

/**
 * Wrapper component for Car to render either a handover button or call direct button depends on if the product is availableOnline
 * @param {Object} props - component's props
 * @param {Object} props.stateProps - stateProps that passed from results_container, including product data and eventHandler
 * @returns {Node} the handover button or call direct button
 * @constructor
 */
const HandoverButton = ({ stateProps, ...buttonProps }) => {
    const { product, eventHandler } = stateProps;
    const availableOnline = product.getIn(['productMeta', 'availableOnline']);
    const providerCode = product.getIn(['providerMeta', 'code']);

    const getProviderDisplayName = (code) => {
        switch (code) {
            case 'BUDD':
                return 'Budget Direct';
            case 'VIRG':
                return 'Virgin';
            case 'EXPO':
                return 'Australia Post';
            case 'OZIC':
                return 'Ozicare';
            case 'WOOL':
                return 'Everyday';
            case '1FOW':
                return '1st For Women';
            case 'HUDD':
                return 'Huddle';
            case 'PROG':
                return 'PD Insurance';
            case 'RETI':
                return 'Retirease';
            case 'REAL':
            case 'REIN':
                return 'Real Insurance';
            case 'EXIG':
                return 'ING';
            case 'ERIC':
                return 'Eric Insurance';
            case 'CARP':
                return 'Carpeesh';
            case 'STEL':
                return 'Stella';
            case 'KOBA':
                return 'KOBA';
            case 'EXOA':
                return 'Oceania';
            case 'BUPA':
                return 'Bupa';
            case 'AHM':
                return 'ahm';
            case 'EXCL':
                return 'Coles';
            default:
                return 'Insurer';
        }
    };

    const provider = getProviderDisplayName(providerCode);

    if (typeof availableOnline === 'boolean') {
        if (!availableOnline) {
            return (
                <Button
                    label="Call Insurer Direct"
                    icon="ctm_angle_right"
                    iconPosition="after"
                    variant="hover_grow_full_width"
                    UIComponent="btn_feature_2_large_semi_rounded"
                    onClick={() => (
                        eventHandler && typeof eventHandler === 'function'
                            ? eventHandler({ id: 'call' })
                            : console.error(`Event Handler Type: ${typeof (eventHandler)}`)
                    )}
                    stateProps={stateProps}
                    {...buttonProps}
                />
            );
        }
    }
    return (
        <InsurerHandoverButton
            label={`Go to ${provider}`}
            icon="ctm_angle_right"
            iconPosition="after"
            target="_blank"
            href="/car-insurance/journey/handover"
            variant="hover_grow_full_width"
            UIComponent="btn_feature_2_large_semi_rounded"
            api={api}
            stateProps={stateProps}
            {...buttonProps}
        />
    );
};

HandoverButton.propTypes = {
    stateProps: PropTypes.object.isRequired
};

export { HandoverButton };
